import TWalkthroughBusinessHoursGuidance from './index.vue';

TWalkthroughBusinessHoursGuidance.install = app => {
  app.component(TWalkthroughBusinessHoursGuidance.name, TWalkthroughBusinessHoursGuidance);
};

export default TWalkthroughBusinessHoursGuidance;
